import { QueryObserverOptions } from "react-query/types/core/types";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";

import { HTTPError, useKy } from "src/common/ky";
import {
  DealerOrganization,
  PaginatedResult,
  PropertyOrganization,
} from "src/common/types";

export const GET_ALL_PROPERTIES_LIST_QUERY_KEY = "ALL_PROPERTIES";
export const useAllPropertyOrganizationsQuery = () => {
  const ky = useKy();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  if (!searchParams.has("pageNumber")) {
    searchParams.set("pageNumber", "1");
  }
  searchParams.sort();

  return useQuery<PaginatedResult<PropertyOrganization>>(
    [GET_ALL_PROPERTIES_LIST_QUERY_KEY, searchParams.toString()],
    () =>
      ky
        .get("property-organizations/search-all", { searchParams })
        .json<PaginatedResult<PropertyOrganization>>()
  );
};

export const GET_ALL_DEALER_ORGANIZATIONS_QUERY_KEY = ["DEALER_ORGANIZATIONS"];
export const useGetAllDealerOrganizationsQuery = (
  options: QueryObserverOptions<DealerOrganization[], HTTPError> = {}
) => {
  const ky = useKy();
  return useQuery<DealerOrganization[], HTTPError>(
    GET_ALL_DEALER_ORGANIZATIONS_QUERY_KEY,
    () => ky.get("dealer-organizations/all").json<DealerOrganization[]>(),
    {
      staleTime: 60 * 1000,
      ...options,
    }
  );
};
